import { ApolloLink, Observable } from '@apollo/client'
import * as Sentry from '@sentry/react-native'
import { isPreviewMode } from './previewMode'

/**
 * Mutations que continuam valendo em preview: encerrar a própria sessão não é
 * escrita de aluno.
 *
 * Sem esta lista o botão Sair virava um logout falso — o cliente apagava o
 * token local e ia para /users/sign_in, mas o UserSignOut nunca chegava ao
 * core, então a sessão do colaborador sobrevivia e o hero_theme, vendo alguém
 * logado, jogava em /courses. O produtor achava que tinha saído e não tinha.
 */
export const PREVIEW_ALLOWED_MUTATIONS = ['UserSignOut']

/**
 * Cinto de segurança do preview do produtor: nenhuma escrita de aluno sai daqui.
 *
 * O servidor já recusa toda escrita de aluno feita por colaborador (autoriza por
 * matrícula), então isto não é a barreira — é o que evita que um call site
 * esquecido dispare uma requisição condenada e estoure um toast de erro na cara
 * do produtor. A flag vive no previewMode, escrita pelo useAdminPreview.
 *
 * Vive fora do apollo.tsx de propósito: aquele módulo instancia o ApolloClient
 * no import e puxa NetInfo/env do Expo, o que derruba qualquer spec que toque
 * nesta lógica (e derrubava as que só importavam useAdminPreview de tabela).
 */
export const previewReadOnlyLink = new ApolloLink((operation, forward) => {
  const isMutation = operation.query.definitions.some(
    (definition) =>
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'mutation',
  )
  const isAllowed = PREVIEW_ALLOWED_MUTATIONS.includes(
    operation.operationName ?? '',
  )

  if (isPreviewMode() && isMutation && !isAllowed) {
    Sentry.captureMessage(
      `Mutation ${operation.operationName} blocked in admin preview`,
      'warning',
    )

    return new Observable((observer) => {
      observer.next({ data: null })
      observer.complete()
    })
  }

  return forward(operation)
})
